

























import { Vue, Component, Prop } from 'vue-property-decorator'
import icon from 'components/presenter/item/ItemIcon'
import PersonAvatar from 'components/account/PersonAvatar.vue'

@Component({
  components: {
    PersonAvatar
  }
})
export default class PresenterSearchResultsItemContent extends Vue {
  icon = icon

  @Prop()
  readonly item!: Json

  click () {
    if (!this.item.deletedAt) {
      this.$emit('select')
      if (+this.$route.params.id !== this.item.id) {
        this.$router.replace('/presenter/'+this.item.id)
      }
    }
  }
}
